export const NOTIFICATION_POPOVER_TEXT = {
  label: '알림',
  loading: 'Loading...',
  readAll: '모두읽기',
} as const;
